import React from 'react';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import PacienteDetail from '../components/PacienteDetail';

export default function PacienteDetailPage() {
  return (
    <DashboardLayout>
      <PacienteDetail />
    </DashboardLayout>
  );
}
